// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3Iwn1","cell":"ColumnAccessor_cell__2GLb6","firstCellAccent":"ColumnAccessor_firstCellAccent__jG07v"};